import { useEffect, useState } from "react";
import { createTrade } from "./StockTradeService";
import { getTradingAccounts } from "./TradingAccountService";
import { getStocks } from "./StockService";

export default function StockTradeForm({ onSaved }) {
  const [accounts, setAccounts] = useState([]);
  const [stocks, setStocks] = useState([]);
  const [tradingAccountId, setTradingAccountId] = useState("");
  const [stockId, setStockId] = useState("");
  const [symbol, setSymbol] = useState("");
  const [stockName, setStockName] = useState("");
  const [tradeType, setTradeType] = useState("BUY");
  const [quantity, setQuantity] = useState("");
  const [price, setPrice] = useState("");
  const [fees, setFees] = useState("");
  const [taxes, setTaxes] = useState("");
  const [tradeDate, setTradeDate] = useState("");
  const [notes, setNotes] = useState("");

  useEffect(() => {
    const load = async () => {
      const [acc, stk] = await Promise.all([getTradingAccounts(), getStocks()]);
      setAccounts(acc || []);
      setStocks(stk || []);
    };
    load();
  }, []);

  const handleStockSelect = (id) => {
    setStockId(id);
    const found = stocks.find((s) => s.id === id);
    if (found) {
      setSymbol(found.symbol || "");
      setStockName(found.name || "");
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!tradingAccountId) return;
    await createTrade({
      tradingAccountId,
      stockId: stockId || null,
      symbol,
      stockName,
      tradeType,
      quantity: quantity ? Number(quantity) : null,
      price: price ? Number(price) : null,
      fees: fees ? Number(fees) : null,
      taxes: taxes ? Number(taxes) : null,
      tradeDate: tradeDate || null,
      notes,
    });
    setTradingAccountId("");
    setStockId("");
    setSymbol("");
    setStockName("");
    setTradeType("BUY");
    setQuantity("");
    setPrice("");
    setFees("");
    setTaxes("");
    setTradeDate("");
    setNotes("");
    if (onSaved) onSaved();
  };

  return (
    <form className="card stack-form" onSubmit={submit}>
      <h3>Add Trade</h3>

      <select value={tradingAccountId} onChange={(e) => setTradingAccountId(e.target.value)} required>
        <option value="">Select trading account</option>
        {accounts.map((a) => (
          <option key={a.id} value={a.id}>
            {a.brokerName} ({a.accountNumber || a.id})
          </option>
        ))}
      </select>

      <select value={stockId} onChange={(e) => handleStockSelect(e.target.value)}>
        <option value="">Select stock (optional)</option>
        {stocks.map((s) => (
          <option key={s.id} value={s.id}>
            {s.symbol} - {s.name}
          </option>
        ))}
      </select>

      <input value={symbol} onChange={(e) => setSymbol(e.target.value)} placeholder="Symbol" required />
      <input value={stockName} onChange={(e) => setStockName(e.target.value)} placeholder="Stock name" />

      <select value={tradeType} onChange={(e) => setTradeType(e.target.value)}>
        <option value="BUY">BUY</option>
        <option value="SELL">SELL</option>
      </select>

      <input
        type="number"
        value={quantity}
        onChange={(e) => setQuantity(e.target.value)}
        placeholder="Quantity"
        required
      />
      <input type="number" value={price} onChange={(e) => setPrice(e.target.value)} placeholder="Price" required />
      <input type="number" value={fees} onChange={(e) => setFees(e.target.value)} placeholder="Fees" />
      <input type="number" value={taxes} onChange={(e) => setTaxes(e.target.value)} placeholder="Taxes" />
      <input type="date" value={tradeDate} onChange={(e) => setTradeDate(e.target.value)} />
      <input value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Notes" />

      <button className="btn btn-primary" type="submit">
        Save
      </button>
    </form>
  );
}
